module.exports = __webpack_public_path__ + "img/ccpit.e3567ef8.png";